export const SPINNING = "spinning";
export const LOAD_TEXT = "load_text";